/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandLinkDto
 */
export interface BrandLinkDto {
    /**
     * Identifier for brand link
     * @type {string}
     * @memberof BrandLinkDto
     */
    linkId?: string;
    /**
     * Brand which is in use by organization or service provider
     * @type {string}
     * @memberof BrandLinkDto
     */
    brandId?: string;
    /**
     * Brand url
     * @type {string}
     * @memberof BrandLinkDto
     */
    url?: string;
}

/**
 * Check if a given object implements the BrandLinkDto interface.
 */
export function instanceOfBrandLinkDto(value: object): boolean {
    return true;
}

export function BrandLinkDtoFromJSON(json: any): BrandLinkDto {
    return BrandLinkDtoFromJSONTyped(json, false);
}

export function BrandLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'linkId': json['linkId'] == null ? undefined : json['linkId'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function BrandLinkDtoToJSON(value?: BrandLinkDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'linkId': value['linkId'],
        'brandId': value['brandId'],
        'url': value['url'],
    };
}

